import { styled, SxProps } from "@mui/material";
import * as React from "react";

export interface CheckboxBgProps {
  checked: boolean;
  className?: string;
  sx?: SxProps;
}

const CheckboxBg: React.FC<CheckboxBgProps> = ({ checked, className, sx = {} }) => {
  return <Bg className={className} checked={checked} sx={sx} />;
};

export default CheckboxBg;

const Bg = styled("div")<{ checked: boolean }>(({ theme, checked }) => ({
  position: "absolute",
  background: theme.palette.common.white,
  opacity: 0,
  height: "16px",
  width: "16px",
  borderRadius: "3px",
  transition: "opacity .3s",
  pointerEvents: "none",
  "&:hover": {
    opacity: 0.7,
  },
  ...(checked && {
    opacity: "1 !important",
  }),
}));
